import CaretIcon from './Caret.svg';

const Caret = ({ open }) => {
  const styles = {
    transform: open ? 'rotate(0)' : 'rotate(-90deg)',
    margin: '0px 8px',
  };

  return <CaretIcon style={styles} />;
};

Caret.propTypes = {
  open: PropTypes.bool,
};

export default Caret;
